<script setup>
import { Errors } from '@/@vxapp/@Enums/Error'

definePage({
  meta: { ...PageMeta.Messages.Preview.Meta, pageTitle: PageMeta.Messages.Preview.Title },
})

import { useMessagesStore } from '@/@vxapp/Messages/useMessagesStore'
import EditableMessagesCard from '@/views/Previews/Messages/EditableMessagesCard.vue'
import { useNotificationsStore } from '@/@vxapp/useNotificationsStore'

const messageStore = useMessagesStore()
const route = useRoute()
const notify = useNotificationsStore()
const localMessageData = ref(null)

onMounted(async () => {
  await init()
})

async function init() {
  const { message, responseCode } = await messageStore.fetch(route.params.guid)

  if (responseCode !== 200) {
    notify.error(`${responseCode}: ${Errors.Messages.FETCH_FAILED}`)

    return
  }

  messageStore.message = message
  localMessageData.value = message
}

/* ** */
</script>

<template>
  <EditableMessagesCard
    v-if="localMessageData"
    :key="localMessageData.messageGUID"
    :is-update="true"
    :is-create="false"
    :message-data="localMessageData"
    @reload-message="init"
  />
</template>
